import { render, staticRenderFns } from "./resultItem.vue?vue&type=template&id=0dae92f4&"
import script from "./resultItem.vue?vue&type=script&lang=js&"
export * from "./resultItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports